import { Route } from 'react-router-dom';
import { ManageRoute } from '../components/auth/ManageRoute.js';
import { AttendanceCalendarPage, AttendanceDayPage } from '../lazyPages.js';
import { MovementsRedirect } from './operations/MovementsRedirect.js';

/* ===========================================================================
 * THE REGISTER — the month, and one date's people. Out of
 * `App.tsx` for the reason `approvalDoorRoutes.tsx` gives (size debt behind a
 * ratchet); spliced in as `{ATTENDANCE_ROUTES}`.
 *
 * Each route carries the same `permission` as its nav row in `navGroups.ts`;
 * `routeGates.test.tsx` fails when the two disagree.
 * ======================================================================== */
export const ATTENDANCE_ROUTES = (
  <>
    {/* The muster roll. No FeatureRoute: attendance is the core of
        every deployment, lean or full, so there is no module whose
        absence would make this page meaningless — the group and
        department controls gate themselves instead. */}
    <Route
      path="attendance-calendar"
      element={
        <ManageRoute permission="attendance.view">
          <AttendanceCalendarPage />
        </ManageRoute>
      }
    />
    {/* THE OTHER HALF OF THE MUSTER ROLL, AS ITS OWN ADDRESS.
        The month is an aggregate you scan; this is the list of
        people for one date, and at this client's size that list can
        reach a thousand rows. One page cannot paginate two
        populations — the list needs pages and the month aggregates
        must not re-fetch every time somebody turns one — so they are
        siblings sharing a filter bar rather than one screen doing
        both.

        A route rather than a tab, because every drill-through into
        it names a DATE: a column header, a month tile's worst day, a
        link pasted into chat. `?date=…&group=…&departmentId=…` is
        the whole of that state, so Back works and the address can be
        sent to somebody else.

        Same gate as its sibling, deliberately: it is one screen's
        worth of the same data, and a day view open to a role that
        cannot see the month would be the hole moved rather than
        closed. */}
    <Route
      path="attendance-calendar/day"
      element={
        <ManageRoute permission="attendance.view">
          <AttendanceDayPage />
        </ManageRoute>
      }
    />
    {/* RETIRED: Movements lives in the Overview's People tab. Old links land
        there, period and filters carried; that page keeps its own gate. */}
    <Route path="attendance/movements" element={<MovementsRedirect />} />
  </>
);
